export const esc = 27
export const enter = 13
export const space = 32
export const up = 38
export const down = 40
export const left = 37
export const right = 39
